module.exports = __webpack_public_path__ + "img/尊享.d92dd240.webp";